import React from "react";
import "./Header.css";
import { FaEnvelope } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  return (
    <section className="Header">
      <div className="header_container">
        <div className="header-left">
          <h2 className="logo_img_holder">
            <Link to="/home">
              <img
                src="/assets/images/logo/brown_money_king.png"
                alt="logo img"
                className="logo_img"
              />
            </Link>
          </h2>
        </div>

        <div className="header-right">
          <div
            className="notification-icon"
            onClick={() => navigate("/notifications")}
          >
            <FaEnvelope />
            <span className="notification-dot"></span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;
